import { useTranslation } from "react-i18next";
import { useToast } from "./useToast";

type SuccessToastProps = {
    titleTranslationKey: string;
    descriptionTranslationKey?: string;
};

const useSuccessToast = () => {
    const { toast } = useToast();
    const { t } = useTranslation();

    const showSuccessToast = ({
        titleTranslationKey,
        descriptionTranslationKey,
    }: SuccessToastProps) => {
        toast({
            title: t(titleTranslationKey),
            description: descriptionTranslationKey
                ? t(descriptionTranslationKey)
                : undefined,
            variant: "success",
        });
    };

    return showSuccessToast;
};

export default useSuccessToast;
